// gatsby-browser.js oder Layout.jsx
import { loadGoogleAnalytics } from "./src/components/utils/loadGoogleAnalytics"

if (process.env.NODE_ENV !== "development") {
  console.log = function () {};
  console.warn = function () {};
  console.error = function () {};
}

export const onClientEntry = () => {
  if (typeof window !== 'undefined') {
    const consent = JSON.parse(localStorage.getItem('vr-quest-settings'))
    if (consent?.analytics === true) {
      loadGoogleAnalytics('G-SS395L5S7L') // <-- dein GA-ID hier eintragen
    }
  }
}